import renderDate from "@helpers/getDealCardDate";
import { DateContainer } from "@components/DealCard/styled";
import { Text } from "@ifgengineering/component-library";
import React from "react";
import { Deal } from "@ifgengineering/client-invest-sdk";

const DateToExpire = ({ deal }: { deal: Deal }) => {
  const { dateColor, dateString } = renderDate(deal);

  if (!dateColor || !dateString) {
    return null;
  }

  return (
    <DateContainer>
      <Text type="U12" color={dateColor} fontFamily="Inter">
        {dateString}
      </Text>
    </DateContainer>
  );
};

export default DateToExpire;
